import React, { useState, useRef, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

const ANSWERS = {
  'налоги': 'По вашему режиму УСН вам нужно платить авансовые платежи до 28 апреля, 28 июля, 28 октября. Декларация — до 31 марта следующего года. НДС не облагается.',
  'ндс': 'На режиме УСН НДС не облагается (ст. 346.11 НК РФ). На ОСНО ставка НДС — 22% с 2026 года.',
  'кассовый разрыв': 'Кассовый разрыв — это когда расходы превышают доходы в конкретный день. Khepri предсказывает разрывы на 14 дней вперёд.',
  'контрагент': 'Проверить контрагента можно на вкладке «Контрагенты». Введите ИНН — Khepri покажет риски.',
  'договор': 'Создать договор можно на вкладке «Договоры». Khepri генерирует договор с учётом вашего налогового режима.',
  'счёт': 'Открыть расчётный счёт можно через вкладку «Банки». Там список из 10 банков с тарифами.',
  'торги': 'Для участия в госзакупках перейдите на вкладку «Тендеры».',
  'гарантия': 'Банковскую гарантию можно оформить через вкладку «Гарантии».',
  '1с': 'Интеграция с 1С уже работает. Перейдите на вкладку «1С».',
  'помощь': 'Я ИИ-Ко-фаундер Khepri. Могу ответить на вопросы о налогах, договорах, контрагентах, торгах, гарантиях, 1С и банках.',
};

function AIChat() {
  const [messages, setMessages] = useState(() => {
    const saved = localStorage.getItem('khepri_chat_history');
    return saved ? JSON.parse(saved) : [
      { from: 'ai', text: '👋 Привет! Я ИИ-Ко-фаундер Khepri. Задайте любой вопрос о бизнесе.' },
    ];
  });
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const chatEnd = useRef(null);

  useEffect(() => {
    chatEnd.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    localStorage.setItem('khepri_chat_history', JSON.stringify(messages));
  }, [messages]);

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;

    setMessages(prev => [...prev, { from: 'user', text }]);
    setInput('');
    setLoading(true);

    try {
      const res = await fetch(API + '/ai/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text }),
      });

      if (res.ok) {
        const data = await res.json();
        setMessages(prev => [...prev, { from: 'ai', text: data.answer }]);
      } else {
        const answer = findAnswer(text.toLowerCase());
        setMessages(prev => [...prev, { from: 'ai', text: answer }]);
      }
    } catch (err) {
      const answer = findAnswer(text.toLowerCase());
      setMessages(prev => [...prev, { from: 'ai', text: answer }]);
    } finally {
      setLoading(false);
    }
  };

  const clearHistory = () => {
    setMessages([
      { from: 'ai', text: '👋 Привет! Я ИИ-Ко-фаундер Khepri. Задайте любой вопрос о бизнесе.' },
    ]);
    localStorage.removeItem('khepri_chat_history');
  };

  const findAnswer = (q) => {
    for (const [key, answer] of Object.entries(ANSWERS)) {
      if (q.includes(key)) return answer;
    }
    return 'Извините, я пока не знаю ответа. Попробуйте спросить про: налоги, НДС, кассовый разрыв, контрагент, договор, счёт, торги, гарантия, 1С, помощь.';
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 180px)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <h2 style={{ color: '#F7DE8A' }}>🤖 ИИ-Ко-фаундер</h2>
        {messages.length > 1 && (
          <button onClick={clearHistory} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>
            Очистить историю
          </button>
        )}
      </div>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 12 }}>
        Спросите меня о налогах, договорах, контрагентах, тендерах и многом другом
      </p>

      <div style={{ flex: 1, overflowY: 'auto', marginBottom: 12, padding: '0 4px' }}>
        {messages.map((m, i) => (
          <div key={i} style={{ marginBottom: 10, display: 'flex', justifyContent: m.from === 'user' ? 'flex-end' : 'flex-start' }}>
            <div style={{
              maxWidth: '80%',
              padding: '10px 14px',
              borderRadius: 12,
              background: m.from === 'user' ? '#F7DE8A' : '#1E293B',
              color: m.from === 'user' ? '#0F172A' : '#F8FAFC',
              fontSize: 14,
              lineHeight: 1.5,
              border: m.from === 'ai' ? '1px solid #8A6636' : 'none',
              whiteSpace: 'pre-wrap',
            }}>
              {m.text}
            </div>
          </div>
        ))}
        {loading && (
          <div style={{ marginBottom: 10, display: 'flex', justifyContent: 'flex-start' }}>
            <div style={{ padding: '10px 14px', borderRadius: 12, background: '#1E293B', color: '#94A3B8', fontSize: 14, border: '1px solid #8A6636' }}>
              Думаю...
            </div>
          </div>
        )}
        <div ref={chatEnd} />
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && send()}
          placeholder="Напишите что-нибудь..."
          style={{
            flex: 1,
            padding: 10,
            background: '#0F172A',
            border: '1px solid #8A6636',
            borderRadius: 8,
            color: '#F8FAFC',
            fontSize: 14,
          }}
        />
        <button
          onClick={send}
          disabled={loading}
          style={{
            padding: '10px 20px',
            background: '#F7DE8A',
            color: '#0F172A',
            border: 'none',
            borderRadius: 8,
            cursor: loading ? 'default' : 'pointer',
            fontWeight: 600,
            opacity: loading ? 0.5 : 1,
          }}
        >
          Отправить
        </button>
      </div>
    </div>
  );
}

export default AIChat;